export const getCartItemCount = (cartItems: any): number => {
  if (!cartItems) {
    return 0;
  }
  if (Array.isArray(cartItems)) {
    return cartItems.length;
  }
  if (Array.isArray(cartItems?.data)) {
    return cartItems.data.length;
  }
  return 0;
};

export const shouldResetAttachments = (
  previousCount: number,
  nextCount: number
): boolean => {
  return previousCount > 0 && nextCount === 0;
};
